


































import { VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import makeUrlResolver from '@/lib/make-url-resolver';
import IconButton from '../_icon-button/icon-button.vue';
import {
    InvestMentHoldingsAction,
    MatchTransactionsAction,
    PeriodUpdatesAction,
    RunReportAction,
    QuestionMarkIcon,
} from '../../assets/icons';

interface IActionMenuLink {
    label: string;
    path: string;
    pathId?: string;
    icon: VueConstructor;
    click?: any;
}

@Component({
    components: {
        InvestMentHoldingsAction,
        MatchTransactionsAction,
        PeriodUpdatesAction,
        RunReportAction,
        QuestionMarkIcon,
        IconButton
    },
})
export default class ShortcutsBar extends Vue {
    @Prop({ default: '' }) public baseUrl: string;
    public get links(): IActionMenuLink[] {
        const resolveUrl = makeUrlResolver(this.baseUrl);
        return [
            {
                path: resolveUrl('investment-register/holding-account'),
                icon: InvestMentHoldingsAction,
                label: 'Holding accounts',
                pathId: 'ha-path',
            },
            {
                path: resolveUrl('event-manager/match-transactions'),
                icon: MatchTransactionsAction,
                label: 'Match transactions',
            },
            {
                path: resolveUrl('periodic-processing/financial-year'),
                icon: PeriodUpdatesAction,
                label: 'Period updates',
            },
            {
                path: resolveUrl('report-register/single-report-viewer'),
                icon: RunReportAction,
                label: 'Run report',
                pathId: 'srv-path',
            }
        ];
    }
}
